import { Conversation } from "@/core/entities/conversation";
import { CategoryKey, CategoryTypeKey } from "@/core/entities/deduction";
import { IConversationRepository } from "@/core/repositories/conversation";

export class GetConversationByReferenceIdUseCase {
  constructor(private readonly conversationRepository: IConversationRepository) { }

  async execute(params: { referenceId: number; categoryKey: CategoryKey; categoryTypeKey?: CategoryTypeKey }): Promise<Conversation> {
    const conversation = await this.conversationRepository.getConversationByReferenceId(
      params.referenceId,
      params.categoryKey,
      params.categoryTypeKey
    );
    return new Conversation(conversation.conversationByReferenceId);
  }
}
